import CryptoJS from 'crypto-js';

export class MD5Helper {
    static CreateMD5(input: string): string {
        return CryptoJS.MD5(input).toString().toUpperCase();
    }
}
